var _path, _circle, _circle2, _circle3, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSubaccount(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 550,
    height: 200,
    viewBox: "0 0 550 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.47716 4.47715 0 10 0H540C545.523 0 550 4.47715 550 10V200H0V10Z",
    fill: "#FFEAE9"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 275,
    cy: 100,
    r: 60,
    fill: "#FCF7F7"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 275,
    cy: 100,
    r: 50,
    fill: "#FFEAE9"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 275,
    cy: 100,
    r: 40,
    fill: "#990A00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M269.389 99.0511L269.422 97.6517C269.434 97.1001 269.855 96.6441 270.404 96.5857L277.299 95.8542C277.952 95.7849 278.519 96.299 278.514 96.9545L278.403 110.255L279.574 110.319C280.157 110.351 280.613 110.832 280.613 111.415V112.573C280.613 113.178 280.124 113.669 279.518 113.671L270.721 113.703C270.107 113.705 269.611 113.205 269.618 112.592L269.632 111.444C269.639 110.865 270.095 110.392 270.673 110.361L271.921 110.295L271.935 100.22L270.453 100.173C269.85 100.155 269.375 99.6536 269.389 99.0511Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M278.664 89.8426C278.664 87.682 276.91 85.9305 274.748 85.9305C272.585 85.9305 270.832 87.682 270.832 89.8426C270.832 92.0036 272.585 93.7551 274.748 93.7551C276.91 93.7551 278.664 92.0036 278.664 89.8426Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M279.575 110.318L278.404 110.254L278.514 96.9536C278.52 96.2978 277.952 95.7837 277.3 95.8529L275.161 96.0798C275.42 96.2815 275.588 96.5959 275.585 96.9536L275.474 110.254L276.645 110.318C277.228 110.349 277.684 110.831 277.684 111.414V112.572C277.684 113.177 277.195 113.668 276.589 113.67L270.576 113.692C270.624 113.698 270.672 113.702 270.722 113.702L279.519 113.67C280.124 113.668 280.613 113.177 280.613 112.572V111.414C280.614 110.831 280.157 110.349 279.575 110.318V110.318Z",
    fill: "#EAEAEA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M274.748 85.9305C274.23 85.9305 273.736 86.032 273.283 86.2146C274.72 86.7942 275.734 88.1998 275.734 89.8426C275.734 91.4857 274.72 92.8913 273.283 93.471C273.736 93.6535 274.23 93.7551 274.748 93.7551C276.911 93.7551 278.664 92.0033 278.664 89.8426C278.664 87.682 276.911 85.9305 274.748 85.9305Z",
    fill: "#EAEAEA"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubaccount);
export default __webpack_public_path__ + "static/media/subaccount.8ac1f710c4c3ecba4595e35b5c17a2e2.svg";
export { ForwardRef as ReactComponent };